import { useEffect, useState } from "react";
import { Type, Lock } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { HEADING_FONTS, loadGoogleFont } from "@/lib/fonts";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const DEFAULT = "__default__";

export const HeadingFontPicker = ({ enabled }) => {
  const [font, setFont] = useState("");
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/restaurant").then((r) => { setFont(r.data.heading_font || ""); setLoaded(true); }).catch(() => setLoaded(true));
    HEADING_FONTS.forEach(loadGoogleFont);
  }, []);

  const save = async (value) => {
    const heading_font = value === DEFAULT ? "" : value;
    try {
      const { data } = await api.put("/restaurant", { heading_font });
      setFont(data.heading_font || "");
      toast.success(heading_font ? `Font "${heading_font}" applicato ai titoli` : "Font predefinito ripristinato");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    }
  };

  if (!loaded) return null;

  return (
    <div className="flex items-center gap-2" data-testid="heading-font-picker">
      <Type className="h-4 w-4 text-[#5aa469]" />
      <span className="text-sm text-gray-500">Font titoli</span>
      <Select value={font || DEFAULT} onValueChange={save} disabled={!enabled}>
        <SelectTrigger className="h-10 w-48 rounded-lg" data-testid="heading-font-select" style={font ? { fontFamily: `"${font}", serif` } : undefined}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={DEFAULT}>Predefinito (design)</SelectItem>
          {HEADING_FONTS.map((f) => (
            <SelectItem key={f} value={f} style={{ fontFamily: `"${f}", serif` }} data-testid={`heading-font-${f.replace(/\s/g, "-").toLowerCase()}`}>{f}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      {!enabled && <Lock className="h-4 w-4 text-gray-400" />}
    </div>
  );
};
